const Info = ({ message, messages, title }) => (
  <div className="ma-info has-background-info has-text-white">
    <div className="info-icon-wrapper">
      <span className="icon">
        <i className="mdi mdi-36px mdi-information" />
      </span>
    </div>
    <div className="info-content-wrapper">
      {title && <div className='info-title'>{title}</div>}
      {messages && messages.length > 1
        ? <ul className='info-message'>{messages.map((m, i) => <li key={i}>{m}</li>)}</ul>
        : <div className='info-message'>{(messages && messages[0]) || message}</div>
      }
    </div>
  </div>
)

Info.defaultProps = {
  message: ''
}

export default Info



// WEBPACK FOOTER //
// ./components/uiLib/Info/index.js